// `REGEX_PATTERNS` now lives canonically in `@/constants/regex`. Re-exported
// here for the few legacy callers still importing it from this module.
export { REGEX_PATTERNS } from '@/constants/regex';

export const STATUS_COLORS = {
  success: { bg: 'success-300', icon: '255, 255, 255', text: 'base-white' },
  error: { bg: 'error-200', icon: '255, 255, 255', text: 'base-white' },
  info: { bg: 'pastel-6-light', icon: '77, 15, 0', text: 'pastel-6-dark' },
  warning: { bg: '#FFF2CC', icon: '242, 153, 74', text: 'base-white' },
  message: { bg: 'secondary-950', icon: '255, 255, 255', text: 'base-white' },
};
export const TOAST_BORDERS = {
  success: 'success-200',
  error: 'error-100',
  info: 'warning-100',
  message: 'secondary-950',
};

export const CALENDAR_PROVIDERS = {
  GOOGLE: 'gcal',
  MICROSOFT: 'mscal',
};

export const ATS_MILESTONES = {
  LEAD: 'Lead',
  APPLIED: 'Applied',
  INTERVIEW: 'Interview',
  OFFER: 'Offer',
  HIRED: 'Hired',
};

// A stage "is Hired" by its MILESTONE, not its name — a job can have several
// custom-named stages that all carry the Hired milestone. Always check the
// milestone (`ats_job_milestone.name`), never the stage's own `name`.
type StageWithMilestone = {
  ats_job_milestone?: { name?: string | null } | null;
} | null;

export const isHiredMilestoneStage = (stage: StageWithMilestone): boolean =>
  stage?.ats_job_milestone?.name === ATS_MILESTONES.HIRED;

export const INTERVIEW_PLAN_MILESTONES_ORDER = [
  ATS_MILESTONES.LEAD,
  ATS_MILESTONES.APPLIED,
  ATS_MILESTONES.INTERVIEW,
  ATS_MILESTONES.OFFER,
  ATS_MILESTONES.HIRED,
];

export const CUSTOM_FIELDS = {
  TEXT: 'TEXT',
  CHOICES: 'CHOICES',
  EVALUATION: 'EVALUATION',
  DATE: 'DATE',
  MISC: 'MISC',
  // Requisition/offer-only category (sources approval reviewers). Intentionally
  // excluded from CUSTOM_FIELD_CATEGORIES so it never surfaces in the shared
  // survey/job-profile tile pickers; the offer drawer's kind list allows it via
  // its own subjectTypes gate.
  USERS: 'USERS',
};

export const CUSTOM_FIELD_CATEGORIES = [
  CUSTOM_FIELDS?.TEXT,
  CUSTOM_FIELDS?.CHOICES,
  CUSTOM_FIELDS?.EVALUATION,
  CUSTOM_FIELDS?.DATE,
  CUSTOM_FIELDS?.MISC,
];

export const EXTERNAL_MEETING_LOCATION = ['hackerrank'];
